import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';

import { setErrorModal } from '../../slices/scene/SceneSlice';
import * as SceneConfig from "_core/configs/SceneConfig";
import { Stack, Modal, HTMLRenderer, Text, Icon } from "_core/components/common/UI";
import * as Constants from "_core/configs/Constants";
import * as LocalStorageUtils from "_core/utils/localstorage";

import './ErrorModal.scss'
import Row from './UI/Row';

const ErrorModal = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { errorModalInfo } = useSelector((store) => store.scene);
    const [modalInstance, setErrorModalInstance] = useState({ class: '', body: <></> });

    useEffect(() => {
        UpdateModal();
    }, [errorModalInfo.show]);

    // 編集モーダルを開く
	const UpdateModal = () => {
		setErrorModalInstance({
			class: errorModalInfo.show ? 'show' : '',
			body: modalBody()
		});
	};

       //モーダルのボディ
	const modalBody = () => {

        let modalTextElement = "";
        if (errorModalInfo.text){
            modalTextElement = errorModalInfo.text.message.replace(/\r\n/g, '\n').replace(/\r/g, '\n').replace(/\r/g, '</br>')
            console.log(modalTextElement);
        }

		return(
            <Stack className="error-modal-message spacing-16px padding-16px">
                <Row className="spacing-16px">
                    <Stack className="flex-center">
                        <Icon icon="x-circle" size={42} className="error-icon"/>
                    </Stack>
                    <Stack className="spacing-8px">
                        <Text className="text-size-large">エラー: {errorModalInfo.text.code}</Text>
                        <HTMLRenderer htmlContent={modalTextElement}></HTMLRenderer>
                    </Stack>
                </Row>
            </Stack>
		)
	}

    // モーダルを閉じるときの処理
    const handleCloseModal = () => {
        const isSessionError = errorModalInfo?.text?.code === 900007;
        dispatch(setErrorModal({ show: false, text: "" }));

        // セッションエラーの場合はログイン画面に遷移する
        if (isSessionError) {
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.sid, "");
            navigate(SceneConfig.PAGES.ACCOUNT_TOP);
        }
    }

    function ShowModal() {
        return (
            <Modal
                className={modalInstance.class}
                dialogclass="modal-dialog-centered"
                name="error-modal"

                showClose={false}
                close={handleCloseModal}
                
                showConfirm={false}
                showCancel={true}
                cancel={handleCloseModal}
                cancelbtnclass="primary-border"
                cancelvalue={"確認"}
                
                body={modalInstance.body}
            />
        );
    }

    return <ShowModal />
}

export default ErrorModal